module.exports = __webpack_public_path__ + "img/logo.c831dd12.png";